import { z } from 'zod';

import { ParticipantSchema } from './participants';
import { LocalDateTimeStringSchema } from '../../common';
import { makeEndpoint } from '../common';

const PriceTierSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  price: z.number(),
  maxQuantity: z.number().optional(),
});

export const RescheduleBookingEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ bookingId }: { bookingId: string }) => `v1/bookings/${bookingId}/reschedule`,
  requestSchema: z.object({
    sessionTime: LocalDateTimeStringSchema,
    sessionDuration: z.number().optional(),
    experienceId: z.string().uuid().optional(),
    sendConfirmationEmail: z.boolean().optional(),
    participants: z.array(ParticipantSchema).optional().nullable(),
    priceTier: PriceTierSchema.optional().nullable(),
    honorCurrentPrice: z.boolean().optional(),
  }),
  responseSchema: z.void(),
});
